var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['reportCard', _vm.isActive],on:{"click":(e) => _vm.$emit('click', e)}},[_vm._m(0),_c('div',{staticClass:"cardTitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"cardDesc"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardImg"},[_c('i',{staticClass:"fal fa-table"})])
}]

export { render, staticRenderFns }